
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers/cleats",
      function () {
        return require("private-next-pages/sneakers/cleats.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers/cleats"])
      });
    }
  